export class PayLater {
  amount: number;
  buyerType: 'Customer' | 'Employee';
  buyerId: string;
  buyerName: string;
  tagNumber?: string;
  employeeCode?: string;
  createdAt?: string;
}
